/** ULAIM 8-arm mark. Same geometry as ulaim-frontend: 4 navy arms (+ and ×),
 *  4 blue tip dots, white centre hub. */
export function Logo({ size = 26 }: { size?: number }) {
  const NAVY = '#0C2336';
  const BLUE = '#3397D7';
  return (
    <svg viewBox="-6 -6 112 112" width={size} height={size} fill="none" aria-hidden>
      <g>
        <rect x="44.5" y="16" width="11" height="68" rx="5.5" fill={NAVY} />
        <rect x="16" y="44.5" width="68" height="11" rx="5.5" fill={NAVY} />
        <rect x="44.5" y="16" width="11" height="68" rx="5.5" fill={NAVY} transform="rotate(45 50 50)" />
        <rect x="44.5" y="16" width="11" height="68" rx="5.5" fill={NAVY} transform="rotate(-45 50 50)" />
        <circle cx="50" cy="4" r="6" fill={BLUE} />
        <circle cx="96" cy="50" r="6" fill={BLUE} />
        <circle cx="50" cy="96" r="6" fill={BLUE} />
        <circle cx="4" cy="50" r="6" fill={BLUE} />
      </g>
      <circle cx="50" cy="50" r="7.5" fill="#FFFFFF" />
    </svg>
  );
}
